import React, {useState} from "react";
import Styles from './styles.module.scss';
import { useTranslation } from "react-i18next";

import closeArrow from '../../theme/assets/svg/lp_about_s8_arrow_close.svg';
import openArrow from '../../theme/assets/svg/lp_about_s8_arrow_open.svg';


const AboutS8 = () => {
    const { t } = useTranslation();

    const [itemOpenId, setItemOpenId] = useState(null);

    return (
        <section className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.contentWrapTitle}`}><span>FAQ</span></div>
                <div className={`${Styles.contentBox}`}>
                    <div
                        className={`${Styles.contentBoxItem} ${itemOpenId === 1 ? Styles.contentBoxItemActive : null}`}
                        onClick={()=>{
                            if(itemOpenId === 1){
                                setItemOpenId(null);
                            } else {
                                setItemOpenId(1);
                            }
                        }}
                    >
                        <div className={`${Styles.contentBoxItemQuestion}`}>
                            <div className={`${Styles.contentBoxItemQuestionText}`}>{t('Что такое HoneeStarter?')}</div>
                            <div className={`${Styles.contentBoxItemQuestionArrow}`}>
                                <img src={itemOpenId === 1 ? openArrow : closeArrow} alt="open/close"/>
                            </div>
                        </div>
                        <div className={`${Styles.contentBoxItemAnswerWrap}`}>
                            <div className={`${Styles.contentBoxItemAnswerBox}`}>
                                <div className={`${Styles.contentBoxItemAnswerNote}`}>{t('HoneeStarter — это безопасный лаунчпад для проектов Web3, где мы отбираем только проверенные, технологически зрелые и экономически обоснованные идеи. Здесь вы получаете возможность участвовать в старте проектов будущего, минимизируя риски и пользуясь прозрачной системой.')}</div>
                            </div>
                        </div>
                    </div>
                    <div
                        className={`${Styles.contentBoxItem} ${itemOpenId === 2 ? Styles.contentBoxItemActive : null}`}
                        onClick={()=>{
                            if(itemOpenId === 2){
                                setItemOpenId(null);
                            } else {
                                setItemOpenId(2);
                            }
                        }}
                    >
                        <div className={`${Styles.contentBoxItemQuestion}`}>
                            <div className={`${Styles.contentBoxItemQuestionText}`}>{t('Почему стоит участвовать через HoneeStarter?')}</div>
                            <div className={`${Styles.contentBoxItemQuestionArrow}`}>
                                <img src={itemOpenId === 2 ? openArrow : closeArrow} alt="open/close"/>
                            </div>
                        </div>
                        <div className={`${Styles.contentBoxItemAnswerWrap}`}>
                            <div className={`${Styles.contentBoxItemAnswerBox}`}>
                                <div className={`${Styles.contentBoxItemAnswerNote}`}>{t('Мы делаем акцент на качество, прозрачность и защиту капитала. Все проекты проходят строгий многоуровневый отбор: анализ экономики, архитектуры, рисков и потенциала роста. Вы заходите в стартапы осознанно, а не на эмоциях.')}</div>
                            </div>
                        </div>
                    </div>
                    <div
                        className={`${Styles.contentBoxItem} ${itemOpenId === 3 ? Styles.contentBoxItemActive : null}`}
                        onClick={()=>{
                            if(itemOpenId === 3){
                                setItemOpenId(null);
                            } else {
                                setItemOpenId(3);
                            }
                        }}
                    >
                        <div className={`${Styles.contentBoxItemQuestion}`}>
                            <div className={`${Styles.contentBoxItemQuestionText}`}>{t('Кто может участвовать?')}</div>
                            <div className={`${Styles.contentBoxItemQuestionArrow}`}>
                                <img src={itemOpenId === 3 ? openArrow : closeArrow} alt="open/close"/>
                            </div>
                        </div>
                        <div className={`${Styles.contentBoxItemAnswerWrap}`}>
                            <div className={`${Styles.contentBoxItemAnswerBox}`}>
                                <div className={`${Styles.contentBoxItemAnswerNote}`}>{t('Любой участник, который прошёл предварительную регистрацию и подтвердил участие в академии ОМТ. Мы создаём сообщество людей, которые ценят безопасность, системный подход и стратегическое мышление.')}</div>
                            </div>
                        </div>
                    </div>
                    <div
                        className={`${Styles.contentBoxItem} ${itemOpenId === 4 ? Styles.contentBoxItemActive : null}`}
                        onClick={()=>{
                            if(itemOpenId === 4){
                                setItemOpenId(null);
                            } else {
                                setItemOpenId(4);
                            }
                        }}
                    >
                        <div className={`${Styles.contentBoxItemQuestion}`}>
                            <div className={`${Styles.contentBoxItemQuestionText}`}>{t('Как принять участие?')}</div>
                            <div className={`${Styles.contentBoxItemQuestionArrow}`}>
                                <img src={itemOpenId === 4 ? openArrow : closeArrow} alt="open/close"/>
                            </div>
                        </div>
                        <div className={`${Styles.contentBoxItemAnswerWrap}`}>
                            <div className={`${Styles.contentBoxItemAnswerBox}`}>
                                <div className={`${Styles.contentBoxItemAnswerList}`}>
                                    <div className={`${Styles.contentBoxItemAnswerListItem}`}>1. {t('Подключиться к платформе с помощью вашего крипто-кошелька или использовать подключения с помощью HoneeAI.')}</div>
                                    <div className={`${Styles.contentBoxItemAnswerListItem}`}>2. {t('Ознакомиться с отобранными проектами и их документацией.')}</div>
                                    <div className={`${Styles.contentBoxItemAnswerListItem}`}>3. {t('Выбрать проект и подключиться к его стартовой фазе через безопасный кошелёк.')}</div>
                                </div>
                                <div className={`${Styles.contentBoxItemAnswerNote}`}><span>*</span>{t('Подробности о каждой фазе и инструкции будут доступны авторизированным участникам.')}</div>
                            </div>
                        </div>
                    </div>
                    <div
                        className={`${Styles.contentBoxItem} ${itemOpenId === 5 ? Styles.contentBoxItemActive : null}`}
                        onClick={()=>{
                            if(itemOpenId === 5){
                                setItemOpenId(null);
                            } else {
                                setItemOpenId(5);
                            }
                        }}
                    >
                        <div className={`${Styles.contentBoxItemQuestion}`}>
                            <div className={`${Styles.contentBoxItemQuestionText}`}>{t('Как мы выбираем проекты?')}</div>
                            <div className={`${Styles.contentBoxItemQuestionArrow}`}>
                                <img src={itemOpenId === 5 ? openArrow : closeArrow} alt="open/close"/>
                            </div>
                        </div>
                        <div className={`${Styles.contentBoxItemAnswerWrap}`}>
                            <div className={`${Styles.contentBoxItemAnswerBox}`}>
                                <div className={`${Styles.contentBoxItemAnswerList}`}>
                                    <div className={`${Styles.contentBoxItemAnswerListTitle}`}>{t('Каждый проект проходит:')}</div>
                                    <div className={`${Styles.contentBoxItemAnswerListItem}`}><span>•</span> {t('технический аудит,')}</div>
                                    <div className={`${Styles.contentBoxItemAnswerListItem}`}><span>•</span> {t('проверку токеномики и экономической модели,')}</div>
                                    <div className={`${Styles.contentBoxItemAnswerListItem}`}><span>•</span> {t('оценку команды и её опыта,')}</div>
                                    <div className={`${Styles.contentBoxItemAnswerListItem}`}><span>•</span> {t('анализ рисков и потенциала роста.')}</div>
                                </div>
                                <div className={`${Styles.contentBoxItemAnswerNote}`}><span>*</span>{t('Мы запускаем только те проекты, которые соответствуют критериям безопасности, прозрачности и долгосрочной ценности.')}</div>
                            </div>
                        </div>
                    </div>
                    <div
                        className={`${Styles.contentBoxItem} ${itemOpenId === 6 ? Styles.contentBoxItemActive : null}`}
                        onClick={()=>{
                            if(itemOpenId === 6){
                                setItemOpenId(null);
                            } else {
                                setItemOpenId(6);
                            }
                        }}
                    >
                        <div className={`${Styles.contentBoxItemQuestion}`}>
                            <div className={`${Styles.contentBoxItemQuestionText}`}>{t('Какие риски есть при участии?')}</div>
                            <div className={`${Styles.contentBoxItemQuestionArrow}`}>
                                <img src={itemOpenId === 6 ? openArrow : closeArrow} alt="open/close"/>
                            </div>
                        </div>
                        <div className={`${Styles.contentBoxItemAnswerWrap}`}>
                            <div className={`${Styles.contentBoxItemAnswerBox}`}>
                                <div className={`${Styles.contentBoxItemAnswerNote}`}>{t('Любое инвестирование связано с риском. В HoneeStarter мы минимизируем риски через строгий отбор, проверку команд и системный подход к каждому проекту. Несмотря на это, капитал всегда остаётся под вашим контролем, а участие — добровольное и осознанное.')}</div>
                            </div>
                        </div>
                    </div>
                    <div
                        className={`${Styles.contentBoxItem} ${itemOpenId === 7 ? Styles.contentBoxItemActive : null}`}
                        onClick={()=>{
                            if(itemOpenId === 7){
                                setItemOpenId(null);
                            } else {
                                setItemOpenId(7);
                            }
                        }}
                    >
                        <div className={`${Styles.contentBoxItemQuestion}`}>
                            <div className={`${Styles.contentBoxItemQuestionText}`}>{t('Что делать, если я новичок в Web3?')}</div>
                            <div className={`${Styles.contentBoxItemQuestionArrow}`}>
                                <img src={itemOpenId === 7 ? openArrow : closeArrow} alt="open/close"/>
                            </div>
                        </div>
                        <div className={`${Styles.contentBoxItemAnswerWrap}`}>
                            <div className={`${Styles.contentBoxItemAnswerBox}`}>
                                <div className={`${Styles.contentBoxItemAnswerNote}`}>{t('Мы предоставляем все необходимые инструкции, образовательные материалы и поддержку сообщества. Даже если вы новичок, вы сможете участвовать безопасно и осознанно, изучая проекты и технологию Web3 на практике.')}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutS8;




